import { render, staticRenderFns } from "./sortGift.vue?vue&type=template&id=4ed042b8&scoped=true&"
import script from "./sortGift.vue?vue&type=script&lang=js&"
export * from "./sortGift.vue?vue&type=script&lang=js&"
import style0 from "./sortGift.vue?vue&type=style&index=0&id=4ed042b8&lang=scss&scoped=true&"
import style1 from "./sortGift.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed042b8",
  null
  
)

export default component.exports